import { useEffect } from 'react';
import { overlayGuard } from '@/containers/PrivacyGuardContextProvider/overlayguard';

export const useOverlayGuard = (isVisible: boolean) => {
  useEffect(() => {
    !!isVisible ? overlayGuard.enter() : overlayGuard.exit();
  }, [isVisible]);
};
